import { useEffect } from 'react';

/**
 * Hook para gerenciar atalhos de teclado
 * 
 * @param {Object} shortcuts - Objeto com os atalhos e suas funções
 * @param {boolean} enabled - Se os atalhos estão habilitados
 * 
 * Exemplos de atalhos:
 * - 'ctrl+a': Ctrl + A
 * - 'escape': Tecla Esc
 * - 'ctrl+shift+s': Ctrl + Shift + S
 */
const useKeyboardShortcuts = (shortcuts = {}, enabled = true) => {
  useEffect(() => {
    if (!enabled) return;

    const handleKeyDown = (event) => {
      const isInInput = (
        event.target.tagName === 'INPUT' ||
        event.target.tagName === 'TEXTAREA' ||
        event.target.isContentEditable
      );

      if (!event.key) return;
      const keyLower = event.key.toLowerCase();

      // Ignorar SEMPRE quando estiver digitando em input/textarea
      // Permitir atalhos apenas quando NÃO estiver em campos de texto
      if (isInInput) {
        // EXCEÇÃO: Escape sempre funciona (para fechar modais/cancelar)
        if (keyLower !== 'escape') {
          return;
        }
      }

      // Construir a chave do atalho
      const keys = [];
      if (event.ctrlKey || event.metaKey) keys.push('ctrl');
      if (event.shiftKey) keys.push('shift');
      if (event.altKey) keys.push('alt');

      // Adicionar a tecla principal
      const key = event.key.toLowerCase();
      keys.push(key);

      const shortcutKey = keys.join('+');

      // Verificar se existe handler para este atalho
      if (shortcuts[shortcutKey]) {
        event.preventDefault();
        shortcuts[shortcutKey](event);
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [shortcuts, enabled]);
};

export default useKeyboardShortcuts;

